import React, { FC } from 'react';

import { ModalContextProvider } from '#/pages/investment/components/productChoose/ModalContext';
import { Steps } from '#/pages/investment/components/productChoose/Steps';

interface PurchaseInvestmentModalProps {
  onClose: () => void;
}

export const PurchaseInvestmentModal: FC<PurchaseInvestmentModalProps> = ({ onClose }) => {
  return (
    <ModalContextProvider onCloseModal={onClose}>
      <Steps />
    </ModalContextProvider>
  );
};
